/**
 * @returns universally formatted date and time
 *
 * @example
 * ```ts
 * dateTimeFormat('2023-01-31T14:08:23Z') === "2023/1/31 17:08"
 * ```
 */
export function dateTimeFormat(date: string) {
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    month: "numeric",
    second: "numeric",
    year: "numeric",
  }).format(new Date(date))
}
